import TailwindButton from "components/general/tailwindButton";

const FooterPersonalPrice = () => {
  return (
    <>
      <div className="flex w-full items-end justify-center sm:-mt-10 mt-10 ">
        <div className="flex w-[350px] h-[360px] sm:w-[1024px] sm:h-[192px] items-end justify-center sm:mt-20 bg-gradient-to-r from-brand-purple to-brand-blue rounded-xl">
          <div className="flex flex-col sm:flex-row w-[346px] h-[356px] sm:w-[1020px] sm:h-[188px] sm:items-end bg-clip-border rounded-xl bg-brand-slate mb-[2px]">
            <div className="flex w-full items-center justify-center  bg-brand-slate h-full rounded-xl">
              <div>
                <div className="flex flex-col items-center">
                  <div className="flex">
                    <p className="font-bold sm:text-5xl text-4xl text-center">
                      Have questions? We&apos;re here to help
                    </p>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:gap-x-5 gap-y-5 sm:gap-y-0 mt-8 items-center">
                    <TailwindButton
                      buttonBGColor="bg-transparent"
                      buttonHeight="h-[40px]"
                      buttonWidth="w-[131px]"
                      buttonBorderColor="border-white"
                      buttonText="Talk to sales"
                      buttonURL="/contact-expert"
                      buttonTextTailwindStyle="font-bold"
                    />
                    <TailwindButton
                      buttonBGColor="bg-transparent"
                      buttonHeight="h-[40px]"
                      buttonWidth="w-[142px]"
                      buttonBorderColor="border-white"
                      buttonText="Read our blog"
                      buttonURL="https://redact.dev/blog"
                      buttonTextTailwindStyle="font-bold"
                    />
                    <TailwindButton
                      buttonBGColor="bg-transparent"
                      buttonHeight="h-[40px]"
                      buttonWidth="w-[98px]"
                      buttonBorderColor="border-white"
                      buttonText="Services"
                      buttonURL="/services"
                      buttonTextTailwindStyle="font-bold"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-28" />
    </>
  );
};

export default FooterPersonalPrice;
